import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-logout",
  "use": "icon-logout-usage",
  "viewBox": "0 0 12 12",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 12 12\" id=\"icon-logout\">\r\n<path d=\"M11.5,5.7L9.6,3.4C9.5,3.3,9.4,3.2,9.3,3.2c-0.1,0-0.1,0-0.2,0C8.9,3.3,8.8,3.5,8.8,3.7v1.4H5.1C4.6,5.1,4.1,5.5,4.1,6\r\n\ts0.4,0.9,0.9,0.9h3.7v1.4c0,0.2,0.1,0.4,0.3,0.4c0.1,0,0.1,0,0.2,0c0.1,0,0.3-0.1,0.4-0.2l1.9-2.3C11.6,6.1,11.6,5.9,11.5,5.7z\r\n\t M6.9,9.7H3.2c-0.5,0-0.9-0.4-0.9-0.9V3.2v0c0-0.5,0.4-0.9,0.9-0.9h3.7c0.5,0,0.9-0.4,0.9-0.9S7.4,0.4,6.9,0.4H2.3\r\n\tc-1,0-1.9,0.8-1.9,1.9v7.5c0,1,0.8,1.9,1.9,1.9h4.7c0.5,0,0.9-0.4,0.9-0.9C7.9,10.1,7.4,9.7,6.9,9.7z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/logout.svg
// module id = KvOj
// module chunks = 164